import React from 'react'
import { Box, Button, Flex, Text } from '@workwhile/ui'
import { useVoiceAgentCallContextValue } from '../../../context/VoiceAgentCallContext'

type ShiftIdDisplayProps = {
  shiftId: number
  onChange: () => void
}

export const ShiftIdDisplay = ({ shiftId, onChange }: ShiftIdDisplayProps) => {
  const {
    state: { callState },
  } = useVoiceAgentCallContextValue()

  const isCallInFlight = callState === 'connecting' || callState === 'active'

  return (
    <Box>
      <Flex alignItems="center" gap={2}>
        <Text fontSize={1} color="lightText">
          Shift ID
        </Text>
        <Text fontSize={2}>{shiftId}</Text>
        <Button
          variant="secondary"
          kind="small"
          onClick={onChange}
          disabled={isCallInFlight}
        >
          Change
        </Button>
      </Flex>
    </Box>
  )
}
